<template lang='pug'>
  div#loadTestRuns
    table-list(:headers='headers'
      :items='loadTestRuns'
      :total='total'
      :loading='loading'
      v-model='selected'
      table-only
      :hasSelection='false'
      :selectAll='false'
      @update='update')
      template(v-slot:empty)
        v-container(v-if='!loading && !loadTestRuns.length')
          v-row
            v-col(align='center' justify='center')
              .text-h5.grey--text No Runs Found
      template(v-slot:row='{item, index, selected, expanded}')
        td
          time-ago(:date='item.createdAt')
        td {{item.total}}
        td {{item.running}}
        td {{item.passing}}
        td {{item.failing}}
        td
          v-row(justify='end')
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon :to='`/load-test/${guid}/results/${item.runGuid}`')
                  v-icon remove_red_eye
              span View Load Test Results
            load-test-download(:guid='guid' :runGuid='item.runGuid')
            v-tooltip(bottom)
              template(v-slot:activator='{on}')
                v-btn(v-on='on' text icon :to='`/results/${item.runGuid}`')
                  v-icon launch
              span View Raw Results
            v-menu(offset-y left)
              template(v-slot:activator='{on}' )
                v-btn(text icon v-on='on' @click.native.stop='')
                  v-icon more_vert
              v-list
                v-list-item(@click='deleteWithPrompt(item)')
                  v-list-item-title
                    | Delete


</template>

<script>
import TableMixin from '@/mixins/table.mixin';
import UtilMixin from '@/mixins/util.mixin';
import TableList from '@/components/TableList';
import TimeAgo from '@/components/TimeAgo';
import Notifications from '@/services/notification.service';
import LoadTest from '@/api/loadTest';
import TestRun from '@/api/testRun';
import LoadTestDownload from './LoadTestDownload';

export default {
  name: 'BionicMetricsLoadTestRuns',
  mixins: [TableMixin, UtilMixin],
  components: {
    LoadTestDownload,
    TimeAgo,
    TableList
  },
  props: {
    guid: {
      type: String,
      required: true
    }
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const {list, total} = await LoadTest.listRuns(this.guid, {
          skip: this.skip,
          limit: this.limit,
          sort: this.sort
        });
        this.loadTestRuns = list;
        this.total = total;
      } catch (error) {
        console.error(`Problem getting list of load-tests: ${error.message}`);
        Notifications.errorToast('Error Loading LoadTests', {duration: 30000, retry: this.load});
      }
      this.loading = false;
    },
    async remove(guid) {
      await TestRun.remove(guid);
      const i = this.loadTestRuns.findIndex((am) => am.guid === guid);
      this.loadTestRuns.splice(i, 1);
    },
    async deleteWithPrompt(run) {
      if (!(await Notifications.confirm('Delete', 'Are you sure you want to delete this run? You will loose access to your data, but billing metrics will remain.'))) return;
      await this.remove(run.guid);
      Notifications.toast('Deleted');
    }
  },
  data() {
    return {
      selected: [],
      headers: [
        {text: 'Started', value: 'createdAt'},
        {text: 'Total', value: 'total', sortable: false},
        {text: 'Running', value: 'running', sortable: false},
        {text: 'Passed', value: 'passing', sortable: false},
        {text: 'Failed', value: 'failing', sortable: false},
        {text: '', value: 'moreActions', sortable: false}
      ],
      loadTestRuns: [],
      total: 0,
      skip: 0,
      limit: 10,
      sort: {createdAt: -1},
      defaultSort: {createdAt: -1},
      loading: false
    };
  }
};
</script>

<style scoped>

</style>
